import type { Testimonial } from "@/types/content";

export const testimonials: Testimonial[] = [
  {
    id: 1,
    name: "陆听澜",
    role: "影视专业在读",
    avatar: "ri-user-3-line",
    text: "看幕后拆解比看正片还上头。尤其是剪辑台那几篇，讲清楚了为什么同一个镜头换个顺序情绪就完全不一样，课上老师都没这么细讲过。",
    rating: 5,
  },
  {
    id: 2,
    name: "周砚青",
    role: "剧组场务",
    avatar: "ri-user-star-line",
    text: "自己在组里待过几年，看到写现场调度的部分特别有共鸣。没有夸大，也没有把幕后写成神话，就是踏踏实实把每天的活讲明白。",
    rating: 5,
  },
  {
    id: 3,
    name: "苏未迟",
    role: "内容编辑",
    avatar: "ri-user-smile-line",
    text: "找选题的时候经常来翻。分类做得很清楚，综艺、影视、剧组各归各位，点进去就是完整一篇，不用在标题党里反复横跳。",
    rating: 5,
  },
  {
    id: 4,
    name: "贺云舟",
    role: "综艺常驻观众",
    avatar: "ri-user-heart-line",
    text: "最爱看嘉宾互动那段的分析，很多当时没看懂的反应，看完幕后才知道原来现场气氛是那样的。更新频率也挺稳。",
    rating: 4,
  },
  {
    id: 5,
    name: "林砚白",
    role: "纪录片爱好者",
    avatar: "ri-user-location-line",
    text: "喜欢它对行业本身的尊重。写的是幕后，但落点始终在「一部作品是怎么被做出来的」，读起来很长见识。",
    rating: 5,
  },
  {
    id: 6,
    name: "程知微",
    role: "夜戏常客",
    avatar: "ri-user-4-line",
    text: "夜戏、雨戏、群戏这些现场的细节太真实了。看得出来写的人真的了解片场，不是坐在屋子里凭空想的。",
    rating: 5,
  },
];